import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthHero from '../components/AuthHero';
import FlowGuard from '../../components/FlowGuard';

const ApplicationSuccessContent: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#F8F9FB] flex">
            {/* Left Side - Success Message */}
            <div className="w-full lg:flex-1 flex items-center justify-center p-4 sm:p-8">
                <div className="w-full max-w-md" style={{ textAlign: 'center' }}>
                    {/* Logo */}
                    <div className="mb-8" style={{ textAlign: 'left' }}>
                        <img
                            src="/branding/logo_blue.svg"
                            alt="Hush"
                            onClick={() => navigate('/')}
                            style={{
                                width: '120px',
                                height: '55px',
                                objectFit: 'contain',
                                cursor: 'pointer'
                            }}
                        />
                    </div>

                    {/* Success Icon */}
                    <div
                        style={{
                            width: '96px',
                            height: '96px',
                            margin: '0 auto 24px',
                            background: 'linear-gradient(135deg, #015FA6 0%, #0284C7 100%)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0px 10px 30px rgba(1, 95, 166, 0.2)',
                        }}
                    >
                        <svg
                            width="52"
                            height="52"
                            viewBox="0 0 24 24"
                            fill="none"
                            style={{ filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))' }}
                        >
                            <path
                                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                stroke="#FFFFFF"
                                strokeWidth={2.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                    {/* Title */}
                    <h1
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 700,
                            fontSize: '32px',
                            color: '#015FA6',
                            marginBottom: '12px'
                        }}
                    >
                        Application Submitted!
                    </h1>

                    {/* Message */}
                    <p
                        style={{
                            fontFamily: 'SF Pro, Manrope',
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '150%',
                            color: '#015FA6',
                            marginBottom: '8px'
                        }}
                    >
                        Thank you for your application!
                    </p>

                    <p
                        style={{
                            fontFamily: 'SF Pro, Manrope',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '150%',
                            color: 'rgba(1, 95, 166, 0.7)',
                            marginBottom: '32px'
                        }}
                    >
                        Our team will review your profile and get back to you soon. We'll send you an email with next steps.
                    </p>

                    {/* Info Box */}
                    <div
                        style={{
                            background: '#FFFFFF',
                            border: '1px solid #CBD5E0',
                            borderRadius: '8px',
                            padding: '20px',
                            marginBottom: '32px',
                            textAlign: 'left'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                gap: '12px'
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                style={{ flexShrink: 0, marginTop: '2px' }}
                            >
                                <path
                                    d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                                    stroke="#015FA6"
                                    strokeWidth={1.5}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div>
                                <h3
                                    style={{
                                        fontFamily: 'Manrope',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: '#015FA6',
                                        marginBottom: '8px'
                                    }}
                                >
                                    What happens next?
                                </h3>
                                <ul
                                    style={{
                                        fontFamily: 'SF Pro, Manrope',
                                        fontSize: '13px',
                                        lineHeight: '160%',
                                        color: 'rgba(1, 95, 166, 0.8)',
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0
                                    }}
                                >
                                    <li style={{ marginBottom: '6px', paddingLeft: '0' }}>
                                        • Our team will review your application within 2-3 business days
                                    </li>
                                    <li style={{ marginBottom: '6px', paddingLeft: '0' }}>
                                        • We'll match your profile with relevant opportunities
                                    </li>
                                    <li style={{ paddingLeft: '0' }}>
                                        • You'll receive an email with personalized recommendations
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <button
                            onClick={() => navigate('/')}
                            style={{
                                width: '100%',
                                padding: '14px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                fontSize: '16px',
                                color: '#F7FAFC',
                                background: '#015FA6',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = '#014880'}
                            onMouseLeave={(e) => e.currentTarget.style.background = '#015FA6'}
                        >
                            Return to Home
                        </button>

                        <button
                            onClick={() => navigate('/contact')}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 500,
                                fontSize: '14px',
                                color: '#015FA6',
                                background: '#FFFFFF',
                                border: '1px solid #CBD5E0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = '#F9FAFB'}
                            onMouseLeave={(e) => e.currentTarget.style.background = '#FFFFFF'}
                        >
                            Contact Us
                        </button>
                    </div>

                    {/* Additional Help */}
                    <p
                        style={{
                            fontFamily: 'SF Pro, Manrope',
                            fontSize: '12px',
                            lineHeight: '150%',
                            color: 'rgba(1, 95, 166, 0.6)',
                            marginTop: '24px'
                        }}
                    >
                        Need help? Check your email for confirmation or{' '}
                        <button
                            onClick={() => navigate('/contact')}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#015FA6',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontFamily: 'SF Pro, Manrope',
                                fontSize: '12px',
                                fontWeight: 500,
                                padding: 0
                            }}
                        >
                            reach out to our team
                        </button>
                    </p>
                </div>
            </div>

            {/* Right Side - Hero */}
            <div className="hidden lg:flex lg:flex-1" style={{ background: '#015FA6' }}>
                <AuthHero />
            </div>
        </div>
    );
};

/**
 * ApplicationSuccess Page
 * Protected by FlowGuard - only accessible after job application flow
 * Direct URL access redirects to candidate jobs page
 */
const ApplicationSuccess: React.FC = () => {
    return (
        <FlowGuard
            requiredStateKey="fromJobApplication"
            fallbackPath="/candidate/jobs"
        >
            <ApplicationSuccessContent />
        </FlowGuard>
    );
};

export default ApplicationSuccess;
